// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"carousel-wrapper_carouselWrapper__757C_","showCarousel":"carousel-wrapper_showCarousel__dg6HF"};